export default "__VITE_ASSET__DIVIFCBD__"